/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {setBrandCard} from '../api'

export const useMutationSetBrandCard = createReactQueryMutationHook('setBrandCard', setBrandCard)
